import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Loader from "../../Common/Loader";
import { importMarketGet } from "../../Server/api";
import { Col, Row } from "react-bootstrap";
import MatchStats_horseAndgreyHound from "../viewmatchAndFancy/MatchStats_horseAndgreyHound";
import axios from "axios";

const HorseRacingDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationPayload = location.state?.payload || {};

  const [loading, setLoading] = useState(true);
  const [runners, setRunners] = useState([]);
  const [raceInfo, setRaceInfo] = useState({});
  const [userBets, setUserBets] = useState([]);
  const [eventId, setEventId] = useState("");
  const [sportId, setSportId] = useState("");
  const [marketId, setMarketId] = useState("");

  // ✅ useRef instead of state so it doesn't trigger re-renders
  const apiCalledRef = useRef(false);

  // ✅ Extract IDs from URL
  useEffect(() => {
    const pathParts = location.pathname.split("/");

    console.log("🧭 Full pathname:", location.pathname);
    console.log("🧭 Path parts:", pathParts);

    // ✅ Event ID (handles both event_id and eventId)
    let eventIdx = pathParts.indexOf("event_id");
    if (eventIdx === -1) eventIdx = pathParts.indexOf("eventId");
    const extractedEventId =
      eventIdx !== -1 && pathParts[eventIdx + 1] ? pathParts[eventIdx + 1] : "";
    setEventId(extractedEventId);

    // ✅ Sport ID (handles both sport_id and sportId) ← YAHAN FIX HAI
    let sportIdx = pathParts.indexOf("sportId");
    if (sportIdx === -1) sportIdx = pathParts.indexOf("sport_id");
    const extractedSportId =
      sportIdx !== -1 && pathParts[sportIdx + 1]
        ? pathParts[sportIdx + 1]
        : "";
    setSportId(extractedSportId);

    // ✅ Market ID (handles market_id, series_idd, marketId)
    let marketIdx = pathParts.indexOf("market_id");
    if (marketIdx === -1) marketIdx = pathParts.indexOf("series_idd");
    if (marketIdx === -1) marketIdx = pathParts.indexOf("marketId");
    const extractedMarketId =
      marketIdx !== -1 && pathParts[marketIdx + 1]
        ? pathParts[marketIdx + 1]
        : "";
    setMarketId(extractedMarketId);

    console.log("🔍 Extracted IDs:", {
      eventId: extractedEventId,
      sportId: extractedSportId,
      marketId: extractedMarketId,
    });

    if (extractedEventId && extractedSportId) {
      if (apiCalledRef.current) {
        console.log("⏭️ API already called, skipping");
        return;
      }
      apiCalledRef.current = true;
      fetchMarketOdds(extractedEventId, extractedSportId, extractedMarketId);
    } else {
      console.error("❌ Missing event or sport ID in URL");
      toast.error("Missing event or sport ID");
      setLoading(false);
    }
  }, [location.pathname]);

  const fetchMarketOdds = async (evId, spId, mId) => {
    setLoading(true);
    try {
      console.log("🔄 Fetching data with:", { evId, spId, mId });

      let basicData = [];
      let marketName = "";
      let matchStartTime = "";

      // ✅ 1️⃣ Basic API
      if (evId && spId) {
        try {
          const admin_id = localStorage.getItem("admin_id") || "admin";
          const role = localStorage.getItem("role") || "1";

          console.log("🔑 Admin ID:", admin_id, "| Role:", role);

          const basicResponse = await importMarketGet(
            spId,
            evId,
            admin_id,
            role
          );
          console.log("📦 Basic API Response:", basicResponse);

          let responseData = null;
          if (basicResponse?.data?.status_code === 1) {
            responseData = basicResponse.data.data || [];
          } else if (basicResponse?.data?.success === true) {
            responseData = basicResponse.data.data || [];
          } else if (
            basicResponse?.data?.data &&
            Array.isArray(basicResponse.data.data)
          ) {
            responseData = basicResponse.data.data;
          } else if (Array.isArray(basicResponse?.data)) {
            responseData = basicResponse.data;
          }

          if (responseData && responseData.length > 0) {
            basicData = responseData;
            const firstItem = basicData[0] || {};
            marketName =
              firstItem.market_name || navigationPayload.venue || "Race";
            matchStartTime = firstItem.match_start_time || "";
            console.log("✅ Basic data loaded:", basicData.length, "runners");
            console.log(
              "📊 Basic data with total_exposure:",
              basicData.map((item) => ({
                name: item.team_name,
                total_exposure: item.total_exposure,
              }))
            );
          } else {
            console.warn("⚠️ Basic API returned empty data");
          }
        } catch (error) {
          console.error("❌ Basic API error:", error);
        }
      }

      // ✅ 2️⃣ Odds API
      let oddsRunners = [];
      if (mId && mId !== "null" && mId !== "undefined" && mId !== "") {
        try {
          const token = localStorage.getItem("accessToken");
          console.log("📡 Calling odds API with marketId:", mId);

          const oddsResponse = await axios
            .get(
              `https://cricketfancylive.shyammatka.co.in/horseracing-grayhond-odds?marketid=${mId}`,
              { headers: { Authorization: `Bearer ${token}` } }
            )
            .catch((err) => {
              console.error("❌ Odds API error:", err.message);
              return { data: [] };
            });

          console.log("🎯 Odds API Response:", oddsResponse.data);

          if (
            oddsResponse.data &&
            Array.isArray(oddsResponse.data) &&
            oddsResponse.data.length > 0
          ) {
            const market = oddsResponse.data[0];
            if (market.runners && Array.isArray(market.runners)) {
              oddsRunners = market.runners.map((runner, index) => ({
                name: runner.runnerName || "Unknown",
                back: runner.ex?.availableToBack?.[0]?.price || "-",
                lay: runner.ex?.availableToLay?.[0]?.price || "-",
                selectionId: runner.selectionId,
                originalIndex: index,
              }));
              console.log(
                "✅ Odds data loaded:",
                oddsRunners.length,
                "runners"
              );
            }
          }
        } catch (oddsError) {
          console.error("❌ Odds API error:", oddsError.message);
        }
      } else {
        console.warn("⚠️ No marketId available, skipping odds API");
      }

      // ✅ 3️⃣ MERGE
      let finalRunners = [];

      if (oddsRunners.length > 0 && basicData.length > 0) {
        const sortedBasicData = [...basicData].sort(
          (a, b) => (a.sort_priority || 0) - (b.sort_priority || 0)
        );

        console.log(
          "📊 Sorted Basic Data:",
          sortedBasicData.map((item) => ({
            name: item.team_name,
            total_exposure: item.total_exposure,
            sort_priority: item.sort_priority,
          }))
        );

        finalRunners = oddsRunners.map((oddRunner, idx) => {
          let matchedName = oddRunner.name;
          let totalExposure = 0;

          if (idx < sortedBasicData.length) {
            const basicItem = sortedBasicData[idx];
            totalExposure = basicItem.total_exposure || 0;

            if (oddRunner.name === "Unknown" || oddRunner.name === "unknown") {
              matchedName = basicItem.team_name || `Runner ${idx + 1}`;
            }
          }

          return {
            name: matchedName,
            back: oddRunner.back,
            lay: oddRunner.lay,
            selectionId: oddRunner.selectionId,
            total_exposure: totalExposure,
          };
        });

        console.log(
          "✅ Merged runners:",
          finalRunners.map((r) => ({
            name: r.name,
            total_exposure: r.total_exposure,
            back: r.back,
            lay: r.lay,
          }))
        );
      } else if (oddsRunners.length > 0) {
        finalRunners = oddsRunners.map((runner, idx) => ({
          name:
            runner.name !== "Unknown" ? runner.name : `Runner ${idx + 1}`,
          back: runner.back,
          lay: runner.lay,
          total_exposure: 0,
        }));
        console.log("✅ Using odds runners (no basic data)");
      } else if (basicData.length > 0) {
        finalRunners = basicData.map((item) => ({
          name: item.team_name || "Unknown",
          back: "-",
          lay: "-",
          team_id: item.team_id,
          market_id: item.market_id,
          total_exposure: item.total_exposure || 0,
        }));
        console.log("✅ Using basic runners (no odds)");
      } else {
        finalRunners = [
          {
            name: "No runners available",
            back: "-",
            lay: "-",
            total_exposure: 0,
          },
        ];
        console.warn("⚠️ No data from any source");
      }

      console.log("🎯 Final Runners:", finalRunners);
      setRunners(finalRunners);

      // ✅ 4️⃣ Race info
      setRaceInfo({
        event_name: navigationPayload.venue || marketName || "Race",
        date: matchStartTime
          ? new Date(matchStartTime).toLocaleDateString("en-US", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : navigationPayload.date || "",
        time: navigationPayload.race_time || "",
        in_play: false,
        race_name: marketName || "Race",
      });

      setUserBets([]);

      if (
        finalRunners.length === 0 ||
        finalRunners[0].name === "No runners available"
      ) {
        toast.warning("No runners found for this race");
      }
    } catch (error) {
      console.error("💥 Fatal error in fetchMarketOdds:", error);
      toast.error("Failed to load market data");
      setRunners([]);
    } finally {
      setLoading(false); // ✅ IMPORTANT: always stop loader
    }
  };

  const formatDisplayDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    if (isNaN(d.getTime())) return date; // ✅ handle invalid dates

    const day = d.getDate();
    const month = d.toLocaleString("en-GB", { month: "short" });

    const suffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${suffix(day)} ${month}`;
  };

  if (!runners.length && !loading) {
    return (
      <div className="card">
        <div className="card-body text-center py-5">
          <h5 className="text-muted">No runners found for this race</h5>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer autoClose={500} theme="colored" />

      <div className="card event_detail">
        <div className="card-body">
          <div className="card-header bgHeader py-1 bg-primary-yellow d-flex justify-content-between align-items-center">
            <h4 className="card-title event_title mb-0">
              {raceInfo.event_name} {formatDisplayDate(raceInfo.date)}
              {raceInfo.in_play && (
                <span className="badge bg-success ms-2">In Play</span>
              )}
            </h4>
            <button className="btn btn-light" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>

          {loading ? (
            <div className="py-5 table_loader text-center">
              {/* <Loader /> */}
            </div>
          ) : (
            <Row className="mt-2">
              <Col md={6}>
                <div className="table-responsive">
                  <table className="table bet_table">
                    <thead className="table-dark">
                      <tr>
                        <th className="fw-bold" style={{ width: "60%" }}>
                          {raceInfo.race_name || "Runners"}
                        </th>
                        <th className="text-center" style={{ width: "20%" }}>
                          BACK
                        </th>
                        <th className="text-center" style={{ width: "20%" }}>
                          LAY
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {runners.length > 0 ? (
                        runners.map((runner, idx) => (
                          <tr key={idx}>
                            <td>
                              <div>{runner.name}</div>
                              {Number(runner.total_exposure) !== 0 && (
                                <div
                                  style={{
                                    color:
                                      Number(runner.total_exposure) > 0
                                        ? "green"
                                        : "red",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    marginTop: "2px",
                                  }}
                                >
                                  {Number(runner.total_exposure) > 0
                                    ? `+${runner.total_exposure}`
                                    : runner.total_exposure}
                                </div>
                              )}
                            </td>
                            <td className="text-center back_bet">
                              {runner.back}
                            </td>
                            <td className="text-center lay_bet">
                              {runner.lay}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No runners available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>

              <div className="col-md-6">
                <MatchStats_horseAndgreyHound />
              </div>
            </Row>
          )}
        </div>
      </div>
    </>
  );
};

export default HorseRacingDetails;